import type { FC } from "react";
import {
	type ClientPortfolioProducerInstrumentResponseDTO,
	ClientPortfolioToolIdentificationTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { ToolTypeRow } from "web_myplann/Portfolio/Components/Redesign/Detail/FundDetail/ToolTypeRow";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

const PageResources = Resources.PortfolioDetail;

type Props = {
	instrument: ClientPortfolioProducerInstrumentResponseDTO;
	currencySign: string;
};

export const ProducerInstrumentFieldRows: FC<Props> = ({
	instrument,
	currencySign,
}) => {
	const { t } = useResource();

	const currentValue = moneyFormatter(
		instrument.currentValue ?? 0,
		currencySign,
		undefined,
		0,
	);

	return (
		<>
			<ToolTypeRow tool={instrument} />
			<DetailRow
				label={t(
					PageResources.LifeInsurance.InvestmentTool.IdentificationType[
						ClientPortfolioToolIdentificationTypeEnum.Isin
					],
				)}
				value={instrument.isin}
			/>
			<DetailRow
				label={t(PageResources.ToolHistory.BankProducts.currentValue)}
				value={currentValue}
			/>
		</>
	);
};
